module.exports = {
    base_url: 'https://ncc2023-api.intellivent.id/',
    // base_url: 'https://indonesia40dev-api.intellivent.id/',
};